/* eslint-disable prettier/prettier */
import React from "react";

/*
Props : 
Status = 'online' , 'offline'
Children = text
*/

const DokanTablePillTags = ({ variant = "normal", children }) => {
  const pillType = {
    completed: "border-none bg-pillColor-completed text-blue",
    processing: "border-green bg-pillColor-green text-white",
    failed: "border-orange bg-orange text-white",
    pending: "border-none bg-orange text-white",
    normal: "bg-pillColor-other border-primary text-secondary",
    "on-hold": "bg-yellow-200 border-yellow-200",
    publish: "bg-green border-green text-white",
  };
  return (
    <span
      className={`border text-2xs px-12px pt-3px pb-5px capitalize rounded-xl ${
        variant in pillType
          ? pillType[variant]
          : "bg-pillColor-other border-primary text-secondary "
      }
      `}
    >
      {children}
    </span>
  );
};

export default DokanTablePillTags;
